<div class="main-page">
    <app-header></app-header>
    <div class="container">
        <ngx-spinner></ngx-spinner>
        <div class="plans-area">

            <div class="plans-area-inner">
                <div *ngIf="subscription && subscription?.length > 0 && subscription[0]?.amount == 0 || !subscription?.length" class="row plan-card" style="margin-bottom:50px;">To begin utilizing our banner plan feature and creating banner advertisements, it is necessary to upgrade your current plan to a paid profile base plan.</div>
                <div class="row">

                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="plan-card">
                            <div>
                                <h3 class="fs-title">My Banner Plans</h3>
                                <div class="myTable">
                                    <table>
                                        <tr>
                                            <th>No.</th>
                                            <th>Subscripition</th>
                                            <th>Status</th>
                                            <th>Valid Till</th>
                                            <th>Total</th>
                                            <th></th>
                                        </tr>
                                        <tr>
                                        <tr *ngFor="let plan of myBannerPlans; let index = index">
                                            <td>{{index+1}}</td>
                                            <td>{{ plan?.caption ? plan?.caption : 'Base Plan'}}</td>
                                            <td> {{plan?.isActive ? "Active" : "Inactive"}} </td>
                                            <td>{{plan?.validTill | date}}</td>
                                            <td>${{ plan?.amount}}</td>
                                            <td *ngIf="plan?.isActive">  <button class="btn btn-danger" (click)="cancelSubscription(plan?._id)" type="button">Cancel Subscription</button> </td>
                                            <td *ngIf="!plan?.isActive">  <button class="btn btn-danger" (click)="reNewPlan(plan?.planId)" type="button">Renew Subscription</button> </td>
                                        </tr>
                                    </table>
                                    <ng-container *ngIf="myBannerPlans?.length === 0">
                                        <p class="w-100 text-center my-4">
                                            No Plans Found
                                        </p>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-12 col-md-offset-3">

                        <form id="msform">
                            <fieldset>
                                <h2 class="fs-title">CREATE YOUR BANNER</h2>
                                <span *ngIf="isDiscount == 'true'" style="margin-top:-10px;">
                                    <small><b>Your plan entitles you to a 50% discount on a promotional banner or ads. Create one today and save!</b></small>
                                </span>
                                <div style="min-height: 250px; margin-top: 1em">
                                    <h5 style="float:left;margin-left:20px;margin-bottom:0px;">Choose Business Category</h5>
                                    <div class="plan-name-area">
                                        <div class="card">
                                            <div class="myTable">
                                                <table>
                                                    <tr>
                                                        <th>Choose Visibilty</th>
                                                        <th>Total</th>
                                                    </tr>
                                                    <tr>
                                                    <tr *ngFor="let plan of allPlans; let index = index">
                                                        <td class="d-flex align-items-center">
                                                            <input
                                                            [disabled]="subscription && subscription?.length > 0 && subscription[0]?.amount == 0 || !subscription?.length" [checked]="plan?.price == bannerPlanType[0]?.amount"
                                                                class="mr-2 radio-btn" type="radio" [id]="plan._id"
                                                                name="bannerPlan"
                                                                (change)="changeBannerPlans(plan, 'banner')"
                                                                id="test@4521" />
                                                            <label class="mb-0" [for]="plan._id">{{ plan?.caption
                                                                }}</label>

                                                        </td>
                                                        <td>${{ plan?.visibiltyPrice }} /
                                                            <span>{{convertSubscripitonType(plan?.days)}}</span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <!-- <h2 class="fs-title">Choose Banner Size Plans</h2> -->

                                <div style="min-height: 250px; margin-top: 1em">
                                    <div class="plan-name-area">
                                        <div class="card">

                                            <div class="myTable">
                                                <table>
                                                    <tr>
                                                        <th>Choose Size</th>
                                                        <th>Total</th>
                                                    </tr>
                                                    <tr>
                                                    <tr *ngFor="let plan of bannerSizePlans; let index = index">
                                                        <td class="d-flex align-items-center">
                                                            <input
                                                            [disabled]="subscription && subscription?.length > 0 && subscription[0]?.amount == 0 || !subscription?.length"
                                                                [checked]="plan?.bannerSize == checkBannerSize"
                                                                class="mr-2 radio-btn" type="radio"
                                                                name="bannerSizePlan"
                                                                (change)="changeBannerPlans(plan, 'size')"
                                                                [id]="plan._id" />
                                                            <label class="mb-0" [for]="plan._id">{{ plan?.bannerSize
                                                                }}</label>
                                                        </td>
                                                        <td>${{ plan?.bannerSizePrice }}/
                                                            <span>{{convertSubscripitonType(plan?.days)}}</span>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <div class="row mTop15" *ngIf="total">
                                                    <div class="col-lg-3 col-md-3 col-sm-3"></div>
                                                    <div class="col-lg-4 col-md-4 col-sm-4">Download Size Template</div>
                                                    <div class="col-lg-4 col-md-4 col-sm-4" >Monthly Total ${{total > 0 ? total:0}}</div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="mt-2" *ngIf="!isSubscribedToBannerPlan() && !isSubscribedToBannerSizePlan()">
                                   <p>You have already subscribed to the Banner Plan</p>
                                </div> -->
                                <button  (click)="next('banner')" type="button"
                                    name="next" class="next action-button btn-success">
                                   Next
                                </button>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
